"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var carsharing_const_1 = require("./carsharing.const");
/**
 * CarsharingService
 * @class
 */
var CarsharingService = /** @class */ (function () {
    function CarsharingService() {
    }
    /**
     * Returns a list of Locations
     * @param version {string}
     * @returns {Promise<GetCitiesResponse[]>}
     */
    CarsharingService.prototype.getCities = function (version) {
        if (version === void 0) { version = 'v1'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getCities.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a list of Locations
     * @param {GetLocationsRequest} data
     * @param {string} version
     * @returns {Promise<GetLocationsResponse[]>}
     */
    CarsharingService.prototype.getLocations = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getLocations
            .replace('{{city}}', data.city)
            .replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, {
            booking_type: data.bookingType,
            end: data.end,
            start: data.start,
        });
    };
    /**
     * Returns Pricing from City & start & end
     * @param {GetPricingRequest} data
     * @param {string} version
     * @returns {Promise<GetPricingResponse[]>}
     */
    CarsharingService.prototype.getPricing = function (data, version) {
        if (version === void 0) { version = 'v3'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getOpenAvailability.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, {
            city_uuid: data.city,
            booking_type: data.bookingType,
            start: data.start,
            end: data.end,
            gps_lat: data.gpsLat,
            gps_lng: data.gpsLng,
            radius: data.radius,
            quota: data.quota,
            filter_booked: data.filterBooked,
            profile: data.profile,
        });
    };
    /**
     * Returns Booking Cost of all categories
     * @param {GetAllBookingCostRequest} data
     * @param {string} version
     * @returns {Promise<GetAllBookingCostResponse[]>}
     */
    CarsharingService.prototype.getAllBookingCosts = function (data, version) {
        if (version === void 0) { version = 'v2'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getAllBookingCost.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, {
            start_date: data.startDate,
            end_date: data.endDate,
            booking_type: data.bookingType,
            city_uuid: data.city,
            profile_type: data.profileType,
            quota: data.quota,
        });
    };
    /**
     * Return all the categories from a city
     * @param {string} city
     * @param {string} type
     * @param {string} version
     * @returns {Promise<GetTariffsResponse[]>}
     */
    CarsharingService.prototype.getTariffs = function (city, type, version) {
        if (version === void 0) { version = 'v2'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getTariffs
            .replace('{{city}}', city)
            .replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, {
            profile_type: type,
        });
    };
    /**
     * Return all the pricing from a city
     * @param {GetCityPricingRequest} data
     * @param {string} version
     * @returns {Promise<GetCityPricingResponse[]>}
     */
    CarsharingService.prototype.getCityPricing = function (data, version) {
        if (version === void 0) { version = 'v3'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getCityPricing
            .replace('{{city}}', data.city)
            .replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, {
            profile: data.profile,
            quota: data.quota,
        });
    };
    /**
     * Return the daily pricing
     * @param {GetDailyRatesRequest} data
     * @param {string} version
     * @returns {Promise<GetDailyRatesResponse[]>}
     */
    CarsharingService.prototype.getDailyRates = function (data, version) {
        if (version === void 0) { version = 'v2'; }
        var url = carsharing_const_1.CARSHARING_ENDPOINTS.getDailyRates
            .replace('{{city}}', data.city)
            .replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url, {
            quota: data.quota,
            profile_type: data.profileType,
            booking_type: data.bookingType,
        });
    };
    return CarsharingService;
}());
/**
 * DirectusService Class Instance
 * @namespace
 */
exports.carsharing = new CarsharingService();
